import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import topicSummaryAct from 'redux/actions/conversations/plugins/topicSummaryAct'

export function usePluginTopicSummary() {
  const dispatch = useDispatch()
  const { activeUser } = useSelector((store) => store.tabs)
  const userConversation = useSelector((store) => store.conversations[activeUser])
  const { plugins } = userConversation || {}
  const topicSummary = plugins?.topicSummary || {}

  const isLoading = topicSummary?.isLoading || false
  const isOpen = topicSummary?.isOpen || false

  const toggleCard = useCallback(() => {
    if (isOpen) {
      dispatch(topicSummaryAct.close())
    } else {
      dispatch(topicSummaryAct.listTopicSummary())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isOpen])

  const onGenerateClick = () => {
    dispatch(topicSummaryAct.generateTopicSummary(topicSummary?.topics?.length > 0))
  }

  return {
    isOpen,
    isLoading,
    toggleCard,
    onGenerateClick,
    topics: topicSummary?.topics || []
  }
}
export default usePluginTopicSummary
